import React, {FC} from 'react';
import styled from 'styled-components';

import {Trans} from '../../../../../libs/shared/core/src/helpers/internationalization/react';
import {AnalyticsPanelId} from '../../../../../libs/shared/core/src/store/panels/panelStateBase';
import {fontWeights} from '../../../../../libs/shared/ui/src/styles/fontStyles';
import {useAppSelector} from '../../../../helpers/appReduxHelpers';
import {
  getAnalyticsReportErrors,
  getAnalyticsReportHasStarted,
  getAnalyticsReportLastUpdated,
  getAnalyticsReportProgress,
} from '../../../../store/panels/analytics/report/analyticsPanelReportSelectors';
import {maybeRenderLoader} from '../../reportHeader/titleRow/reportHeaderLoaderHelper';
import {KnowledgeBaseReportHeaderFilters} from './knowledgeBaseReportHeaderFilters';

/*
 * Props.
 */

interface KnowledgeBaseReportHeaderProps {
  panelId: AnalyticsPanelId;
}

/*
 * Style.
 */

const StyledHeaderHeaderContainerDiv = styled.div`
  margin: 0 auto;
  max-width: 1200px;
  width: 100%;
  padding: 0 48px;
`;

const StyledReportHeaderWrapperDiv = styled.div`
  display: flex;
  align-items: baseline;
  gap: 16px;
  margin-bottom: 20px;
`;

const StyledReportTitleDiv = styled.div`
  margin-right: 8px;
  color: ${(p) => p.theme.greys.shade90};
  font-size: 24px;
  font-weight: ${fontWeights.black};
`;

/*
 * Component.
 */

export const KnowledgeBaseReportHeader: FC<KnowledgeBaseReportHeaderProps> = ({panelId}) => {
  const reportProgress = useAppSelector(getAnalyticsReportProgress);
  const reportHasStarted = useAppSelector(getAnalyticsReportHasStarted);
  const reportLastUpdated = useAppSelector(getAnalyticsReportLastUpdated);
  const errors = useAppSelector(getAnalyticsReportErrors);

  return (
    <StyledHeaderHeaderContainerDiv>
      <StyledReportHeaderWrapperDiv>
        <StyledReportTitleDiv>
          <Trans id="analytics-automation-reports-knowledge-base-header">Knowledge base</Trans>
        </StyledReportTitleDiv>

        {maybeRenderLoader(errors, reportProgress, reportHasStarted, reportLastUpdated)}
      </StyledReportHeaderWrapperDiv>
      <KnowledgeBaseReportHeaderFilters panelId={panelId} />
    </StyledHeaderHeaderContainerDiv>
  );
};
